import { render } from "./DevModeBanner.vue?vue&type=template&id=2f96c3b0&scoped=true"
import script from "./DevModeBanner.vue?vue&type=script&lang=js"
export * from "./DevModeBanner.vue?vue&type=script&lang=js"

import "./DevModeBanner.vue?vue&type=style&index=0&id=2f96c3b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f96c3b0"]])

export default __exports__